<form (ngSubmit)="search.emit()">
  <i class="material-icons">&#xE8B6;</i>
  <input [(ngModel)]="searchQuery" [ngModelOptions]="{standalone: true}"/>
</form>
